/**
 * @flow
 */
'use strict';

export const tobaccoUseCodes = [
{"code":"Never smoker"},
{"code":"Prefers not to answer"},
{"code":"Current every day smoker"},
{"code":"Current some day smoker"},
{"code":"Former smoker"},
{"code":"Heavy tobacco smoker"},
{"code":"Light tobacco smoker"}
]

export const alcoholUseCodes = [
{"code":"Denies"},
{"code":"Prefers not to answer"},
{"code":"Admits"},
{"code":"Previous"},
{"code":"Moderate"},
{"code":"Excessive"},
{"code":"Social"}
]

export const drugUseCodes = [
{"code":"Denies"},
{"code":"Prefers not to answer"},
{"code":"Admits"},
{"code":"Cocaine"},
{"code":"Ecstacy"},
{"code":"Marijuana"},
{"code":"Methamphetamine"}
]
